import * as io from "io-ts";

export const LeavingSiteDataResolver = io.type({
    title: io.string,
    subtitle: io.union([io.string, io.null]),
});

export type LeavingSiteDataType = io.TypeOf<typeof LeavingSiteDataResolver>;
